import { render, staticRenderFns } from "./Fans.vue?vue&type=template&id=cded4094"
import script from "./Fans.vue?vue&type=script&lang=js"
export * from "./Fans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports